import getItemsToDisplayIds from './get-items-to-display-ids';
const sortResponseData = (data = [], itemsToDisplay = []) => {
  const idsToDisplay = getItemsToDisplayIds(itemsToDisplay);
  if (!idsToDisplay.length) return data;
  return idsToDisplay.map(id => data.find(({
    id: resultId
  }) => id === resultId)).filter(Boolean);
};
export default sortResponseData;
//# sourceMappingURL=sort-response-data.js.map